module.exports = __webpack_public_path__ + "static/media/circle.e668b679.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circle.svg
// module id = 362
// module chunks = 0